import { render } from "./BannerRedesSociais.vue?vue&type=template&id=bc2cc07c&scoped=true"
import script from "./BannerRedesSociais.vue?vue&type=script&lang=js"
export * from "./BannerRedesSociais.vue?vue&type=script&lang=js"

import "./BannerRedesSociais.vue?vue&type=style&index=0&id=bc2cc07c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc2cc07c"]])

export default __exports__